import {
    AfterContentInit,
    ContentChildren,
    Directive,
    ElementRef,
    EventEmitter,
    Input,
    Output,
    QueryList, Renderer2
} from '@angular/core';
import {SortableDirective} from './sortable.directive';
import {MainHelper} from "../models/main-helper";

export interface SortEvent{
    currentIndex: number;
    newIndex: number;
}

const distance = (rectA: ClientRect, rectB: ClientRect): number =>{
    return Math.sqrt(
        Math.pow(rectB.top - rectA.top, 2) +
        Math.pow(rectB.left - rectA.left, 2)
    )
};

const hCenter = (rect: ClientRect): number =>{
    return rect.left + rect.width / 2;
};

const vCenter = (rect: ClientRect): number =>{
    return rect.top + rect.height / 2;
};

@Directive({
    selector: '[appSortableList]'
})
export class SortableListDirective implements AfterContentInit{
    constructor(){
    };

    @ContentChildren(SortableDirective) sortables: QueryList<SortableDirective>;

    @Output() sort = new EventEmitter<SortEvent>();

    @Input('appSortableList')
    set appSortableList(update: boolean){
        if (update){
            this.sortables.forEach(sortable =>{
                if (sortable.dragStart.observers.length === 1){
                    this.subscribeDragStart(sortable)
                }

                if (sortable.dragMove.observers.length === 1){
                    this.subscribeDragMove(sortable)
                }
            });
        }
    }

    private clientRects: ClientRect[];

    ngAfterContentInit(): void{
        this.sortables.forEach(sortable =>{
            this.subscribeDragMove(sortable);
            this.subscribeDragStart(sortable);
        });

    }

    private subscribeDragMove = (sortable): void =>{
        sortable.dragMove.subscribe(event =>{
            this.detectSorting(sortable, event);
            let offsetTop = sortable.element.nativeElement.offsetTop;
            let offsetHeight = sortable.element.nativeElement.offsetHeight;
            let parOffsetTop = sortable.element.nativeElement.parentElement.offsetTop;
            let parOffsetHeight = sortable.element.nativeElement.parentElement.offsetHeight;
            let scroll = sortable.element.nativeElement.parentElement.scrollTop;

            if ((parOffsetTop + parOffsetHeight + scroll - 2 * offsetHeight) - offsetTop < 1){
                sortable.element.nativeElement.parentElement.scrollTo({
                    top: scroll + offsetHeight,
                    left: 0,
                    behavior: 'smooth'
                });
                this.measureClientRects()
            } else if ((offsetTop - parOffsetTop - scroll - 2 * offsetHeight) < 1){
                sortable.element.nativeElement.parentElement.scrollTo({
                    top: scroll - offsetHeight,
                    left: 0,
                    behavior: 'smooth'
                });
                this.measureClientRects()
            }
        });
    }

    private subscribeDragStart = (sortable): void =>{
        sortable.dragStart.subscribe(() =>{
            this.measureClientRects()
        });

    }

    private measureClientRects(){
        this.clientRects = this.sortables.map(sortable => sortable.element.nativeElement.getBoundingClientRect());
    }

    private detectSorting(sortable: SortableDirective, event: PointerEvent){
        const currentIndex = this.sortables.toArray().indexOf(sortable);
        const currentRect = this.clientRects[currentIndex];

        this.clientRects
            .slice()
            .sort((rectA, rectB) => distance(rectA, currentRect) - distance(rectB, currentRect))
            .filter(rect => rect !== currentRect)
            .some(rect =>{
                const isHorizontal = rect.top === currentRect.top;
                const isBefore = isHorizontal ?
                    rect.left < currentRect.left :
                    rect.top < currentRect.top;

                // refactored this part a little bit after my Youtube video
                // for improving readability
                const moveBack = isBefore && (isHorizontal ?
                        event.clientX < hCenter(rect) :
                        event.clientY < vCenter(rect)
                );

                const moveForward = !isBefore && (isHorizontal ?
                        event.clientX > hCenter(rect) :
                        event.clientY > vCenter(rect)
                );


                if (moveBack || moveForward){
                    this.sort.emit({
                        currentIndex: currentIndex,
                        newIndex: this.clientRects.indexOf(rect)
                    });

                    return true;
                }

                return false;
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/sortable-list.directive.ts